import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  deleteLogo,
  LOGO,
  setLocalImageSrc,
} from "../../constants/localStorageKeys";
import {
  getAuthLogo,
  getAuthStartPagePicture,
} from "../../helpers/backend_helper";

export const getAuthLogoThunk = createAsyncThunk<
  { authLogo: File | null },
  undefined,
  { rejectValue: Error }
>("authLogoSlice/getAuthLogoThunk", async (_, { rejectWithValue }) => {
  try {
    const logo = await getAuthLogo();

    if (logo?.size) {
      setLocalImageSrc(logo, LOGO);
    } else {
      deleteLogo();
    }

    return { authLogo: logo?.size ? logo : null };
  } catch (error) {
    const { data } = error as {
      data: Error;
    };
    return rejectWithValue({ ...data });
  }
});

export const getAuthStartPagePictureThunk = createAsyncThunk<
  { startPagePicture: File | null | NonNullable<unknown> },
  undefined,
  { rejectValue: Error }
>(
  "authLogoSlice/ getAuthStartPagePictureThunk",
  async (_, { rejectWithValue }) => {
    try {
      const logo = await getAuthStartPagePicture();
      return { startPagePicture: logo?.size ? logo : {} };
    } catch (error) {
      const { data } = error as {
        data: Error;
      };
      return rejectWithValue({ ...data });
    }
  }
);
